import React from 'react';
import { Empty, Button } from 'antd';
import { Link } from 'react-router-dom';

export default function EmptyState({
  description = 'No hay elementos para mostrar',
  actionText,
  actionLink,
}) {
  return (
    <Empty
      description={description}
      style={{ padding: '60px 0' }}
    >
      {actionText && actionLink && (
        <Link to={actionLink}>
          <Button type="primary">{actionText}</Button>
        </Link>
      )}
    </Empty>
  );
}
